import './init'
import './i18n'

import React from 'react'
import { createRoot } from 'react-dom/client'

import 'symbol-observable'

import App from './app'

const container = document.getElementById('app-container')

const root = createRoot(container!)

root.render(<App />)
